import React, { memo } from 'react'

import { Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { elementType, object, shape, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'
import VariationInfo from 'Pods/ThreeDStudio/Shared/VariationInfo/VariationInfo'

function Details({ variation, variationType = undefined }) {
  return (
    <div className="variations-tree__details">
      {variationType && (
        <span className="variations-tree__type cgt-caption-semibold">
          <Icon notSpaced svgComponent={variationType.icon} color="dark" size={iconSize} />
          {variationType.label}
        </span>
      )}
      <VariationInfo variation={variation} isCompact />
    </div>
  )
}

Details.propTypes = {
  variation: object.isRequired,
  variationType: shape({
    icon: elementType,
    label: string,
  }),
}

export default memo(Details)
